/**
 * @fileoverview GET handler for the "/engagement/canvas/send_to_destination_related_canvases" endpoint
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createGetFetcherFunctionWithShadowError";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCanvasSendToDestinationRelatedCanvases } from "./constants";
import type {
  GetEngagementCanvasSendToDestinationRelatedCanvasesResult,
  GetEngagementCanvasSendToDestinationRelatedCanvasesErrors,
} from "./types";
import { isGetEngagementCanvasSendToDestinationRelatedCanvasesResult } from "./validators";

export const getEngagementCanvasSendToDestinationRelatedCanvases = reactQueryFetcherAdapter(
  engagementCanvasSendToDestinationRelatedCanvases,
  createGetFetcherFunctionWithShadowError<GetEngagementCanvasSendToDestinationRelatedCanvasesErrors>()(
    (
      signal: AbortSignal,
      canvas_id: string,
      app_group_id: string
    ): Promise<GetEngagementCanvasSendToDestinationRelatedCanvasesResult> => {
      return fetch(
        `/engagement/canvas/send_to_destination_related_canvases/${canvas_id}`,
        "GET",
        { app_group_id },
        { signal },
        { propagateFetchRequestError: false }
      );
    }
  ),
  isGetEngagementCanvasSendToDestinationRelatedCanvasesResult
);
